import React, { useEffect } from "react";
import "./Blog_outer_tab_Social_Media.css";
import { Link } from "react-router-dom";
import { use } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSocialmedia } from "../../../../features/socialmedia/Slice";

const socialMediaLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/profcymaglobal/",
    imgSrc: "/assets/Images/Blog/Social_media_img/instagram.png",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/71181720/admin/dashboard/",
    imgSrc: "/assets/Images/Blog/Social_media_img/linkedin.png",
  },
  {
    name: "Twitter/X",
    url: "https://x.com/?logout=1732798679923",
    imgSrc: "/assets/Images/Blog/Social_media_img/twitter.png",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profcymaglobal",
    imgSrc: "/assets/Images/Blog/Social_media_img/facebook.png",
  },
];

function Blog_outer_tab_Social_Media() {

  const socialmedia = useSelector((state)=>state.socialmedia.addSocialmedia);
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(getSocialmedia());
  }, [dispatch]);

  return (
    <section className="Blog_outer_tab Blog_outer_tab_Social_Media">
      <div className="categories-container">
        <h3 className="categories-title">Social Media Links</h3>
        <ul className="categories-list">
          
          {socialmedia.map((social, index) => (
            <li key={index}>
              <div className="list_text_holder">
                <div className="social_media_img_holder_main">
                  <div className="social_media_img_holder">
                  {/* process.env.REACT_APP_IMG_URL + need.image */}
                    <img
                      src={process.env.REACT_APP_IMG_URL + social.image}
                      className="social_media_img"
                      alt={`${social.name} logo`}
                    />
                  </div>
                </div>
                <Link to={social.url} target="_blank">
                  <p>{social.url}</p>
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Blog_outer_tab_Social_Media;